import React from 'react';
import { cn } from '../../utils/cn';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../shared/SafeIcon';

export default function OptionCard({ label, selected, onClick, type = 'single' }) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "w-full text-left p-5 rounded-2xl border-2 transition-all duration-300 flex items-center justify-between group",
        selected 
          ? "border-[#7C3AED] bg-purple-50 shadow-md transform scale-[1.01]" 
          : "border-slate-100 bg-white hover:border-purple-200 hover:bg-slate-50"
      )}
    >
      <span className={cn(
        "text-lg font-bold",
        selected ? "text-[#4C1D95]" : "text-slate-700"
      )}>
        {label}
      </span>
      
      <div className={cn(
        "flex-shrink-0 ml-4 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-all",
        type === 'multiple' ? "rounded-lg" : "rounded-full",
        selected 
          ? "border-[#7C3AED] bg-[#7C3AED]" 
          : "border-slate-200 group-hover:border-purple-300"
      )}>
        {selected && (
          <SafeIcon icon={FiIcons.FiCheck} className="text-white text-sm" />
        )}
      </div>
    </button>
  );
}